import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import SlateTextInput from '../Shared/SlateTextInput';
import Verification2faCodeForm from '../Verification2faCode/Verification2faCodeForm';
import FormWrapper from '../../containers/Forms/FormWrapper';
import { route, entityNames } from '../../config/constants';
import './styles.css';

class StartComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailOrPhone: '',
      password: '',
      code: '',
    };
  }

  componentDidMount() {
    const { fetchReset } = this.props;
    if (fetchReset) {
      fetchReset(entityNames.CREATE_AUTH_TOKEN);
    }
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    const { emailOrPhone, password } = this.state;
    const { login, returnTo } = this.props;

    login({ emailOrPhone, password, returnTo }, entityNames.CREATE_AUTH_TOKEN);
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSubmit(e);
    }
  };

  handle2faSubmit = (data) => {
    const { loginWith2faCode } = this.props;
    loginWith2faCode(data, entityNames.LOGIN_2FA_CODE_VERIFICATION);
  };

  render() {
    const { t, isOpenLogin2faDialog, isFetching, errorAction, dataErrors } = this.props;
    const { emailOrPhone, password } = this.state;

    // Show 2FA verification form if needed
    if (isOpenLogin2faDialog) {
      return (
        <div className="login-start">
          <div className="login-start-logo" />
          <div className="login-start-card">
            <h1 className="login-start-title">{t('login:verificationCode')}</h1>
            <FormWrapper
              entityName={entityNames.LOGIN_2FA_CODE_VERIFICATION}
              entity={['code']}
              onSubmit={this.handle2faSubmit}
              noValidation={true}
            >
              <Verification2faCodeForm />
            </FormWrapper>
          </div>
        </div>
      );
    }

    return (
      <div className="login-start">
        <div className="login-start-logo" />
        <div className="login-start-subtitle">Dashboard</div>

        <div className="login-start-card">
          <form className="login-start-form" onSubmit={this.handleSubmit}>
            <SlateTextInput
              name="emailOrPhone"
              type="text"
              label={t('login:emailOrPhone')}
              value={emailOrPhone}
              onChange={this.handleInputChange}
              onKeyPress={this.handleKeyPress}
              autoComplete="email"
              error={dataErrors && dataErrors.emailOrPhone}
              fullWidth
            />

            <SlateTextInput
              name="password"
              type="password"
              label={t('login:password')}
              value={password}
              onChange={this.handleInputChange}
              onKeyPress={this.handleKeyPress}
              autoComplete="current-password"
              error={dataErrors && dataErrors.password}
              fullWidth
            />

            <button
              type="submit"
              className="login-start-btn login-start-btn--primary"
              disabled={isFetching}
            >
              {isFetching ? t('login:loggingIn') : t('login:logIn')}
            </button>

            {errorAction && (
              <div className="auth-form-error">
                {errorAction}
              </div>
            )}
          </form>

          <Link to={route.RESET_PASSWORD} className="login-start-link">
            {t('login:forgotPassword')}
          </Link>

          <div className="login-start-divider">
            <span>{t('login:or')}</span>
          </div>

          <Link
            to={route.CREATE_PROFILE}
            className="login-start-btn login-start-btn--secondary"
          >
            {t('btn:createProfile')}
          </Link>
        </div>
      </div>
    );
  }
}

export const Start = StartComponent;
